// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_4-0";
export var footer = "_4-2";
export var infoSection = "_4-3";
export var infoSectionContainer = "_4-4";
export var infoSectionTitleRow = "_4-5";
export var itemDetails = "_4-6";
export var line = "_4-7";
export var lineItemImage = "_4-1";
export var lineItems = "_4-8";
export var modalContent = "_4-9";
export var multiLineInfo = "_4-a";
export var orderName = "_4-b";
export var strong = "_4-c";